import request from '@/utils/request'

// 查询商家旺店通配置
export function getMerchantWangDian(data) {
  return request({
    url: '/biz/admin/merchant/wangdian/detail',
    method: 'get',
    params: data
  })
}

// 保存商家旺店通配置（无则新增，有则修改）
export function saveMerchantWangDian(data) {
  return request({
    url: '/biz/admin/merchant/wangdian/save',
    method: 'post',
    data: data
  })
}
